import { createFileRoute } from '@tanstack/react-router';
import { ComplaintsPage } from '@/features/people/pages/complaints-page';

export const Route = createFileRoute('/_app/complaints')({ component: ComplaintsPage });
